// SSE event envelopes emitted by services/realtime
// (see doc/intel-realtime-architecture.md). Body is parsed via Zod and
// dropped on parse fail so a malformed frame can't propagate into UI state.

import { intel as i } from '@eidollon/contracts';
import { z } from 'zod';

/** Single signal frame: `event: signal\ndata: {...IntelSignal}`. */
export const SignalEvent = i.IntelSignal;
export type SignalEvent = z.infer<typeof SignalEvent>;

/** Coalesced frame: `event: signal_batch\ndata: {count, type, items}`. */
export const SignalBatchEvent = z
  .object({
    count: z.number().int().nonnegative(),
    type: i.SignalType,
    items: z.array(i.IntelSignal).max(500),
  })
  .strict();
export type SignalBatchEvent = z.infer<typeof SignalBatchEvent>;

export type ParsedFrame =
  | { kind: 'signal'; signal: SignalEvent; eventId: string | null }
  | { kind: 'signal_batch'; batch: SignalBatchEvent; eventId: string | null };
